import { IBannerDetailsMediaComponent } from "./banner-details-media.component";
import { ImagesSliderComponent } from "./elements/images-slider.component";
import { StaticImageComponent } from "./elements/static-image.component";
import { VideoComponent } from "./elements/video.component";
import { BannerDetailsMediaType } from "./types/banner-details-media.type";

export class BannerDetailsMediaFactory {
    public static MEDIA_SELECTOR: string = ".js-ina-banner-details-media";

    public getBrandDetailsMedia(context: JQuery): IBannerDetailsMediaComponent {
        const mediaType = context.data("mediaType") as BannerDetailsMediaType;

        switch (mediaType) {
            case "static-image": {
                const singleImage = new StaticImageComponent();
                singleImage.init(context);

                return singleImage;
            }
            case "images-slider": {
                const sliderContext = $(ImagesSliderComponent.SELECTOR, context);
                const slider = new ImagesSliderComponent();
                slider.init(sliderContext);

                return slider;
            }
            case "video": {
                const video = new VideoComponent();
                video.init(context);

                return video;
            }
        }
    }
}
